import PropTypes from "prop-types";
import React from "react";
import { Navigate } from "react-router-dom";

import LottieSpinner from "./LottieSpinner";

const AdminRoute = ({ element, user, loadingUser }) => {
    // Show spinner while loading user
    if(loadingUser) return <LottieSpinner />;

    // Unauthenticated
    if(!user?.id) return <Navigate to="/unauthorized?auto=1" replace />;

    // Wrong role
    if(user.role !== "admin") return <Navigate to="/access-denied" replace />;

    // Admin OK
    return element;
};

AdminRoute.propTypes = {
    element: PropTypes.node.isRequired,
    user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        role: PropTypes.string,
    }),
    loadingUser: PropTypes.bool,
};
export default AdminRoute;
